import React from "react";
import { Button } from "react-bootstrap";

interface DeleteButtonProps {
    onClick: any;
    size: "sm" | "lg" | undefined
}

export default function DeleteButton(props: DeleteButtonProps) {

    return (
        <Button
            variant='outline-danger'
            style={{ marginLeft: '10px' }}
            onClick={(event) => { props.onClick?.(event) }}
            size={props.size}
        >
            Удалить
        </Button>
    );
}